const Act2020 = [
  {
    path: '/keysight200106/index',
    name: 'keysight200106',
    component: resolve => require(['@/act2020/keysight200106/index'], resolve),
    meta: {
      title: '是德工业4.0及物联网特别活动'
    }
  },
  {
    path: '/meeting200108/index',
    name: 'meeting200108',
    component: resolve => require(['@/act2020/meeting200108/index'], resolve),
    meta: {
      title: '线下在线研讨会报名' // scrm
    }
  },
  {
    path: '/luomu200110/index',
    name: 'luomu200110',
    component: resolve => require(['@/act2020/luomu200110/index'], resolve),
    meta: {
      title: '螺母评估板' // scrm
    }
  },
  {
    path: '/infineon200113/index',
    name: 'infineon200113',
    component: resolve => require(['@/act2020/infineon200113/index'], resolve),
    meta: {
      title: '英飞凌' // scrm
    }
  },
  {
    path: '/rohm200120/index',
    name: 'rohm200120',
    component: resolve => require(['@/act2020/rohm200120/index'], resolve),
    meta: {
      title: '罗姆' // scrm
    }
  },
  {
    path: '/adi200219/index',
    name: 'adi200219',
    component: resolve => require(['@/act2020/adi200219/index'], resolve),
    meta: {
      title: '小体积45W数字PD方案' // adi活动-SCRM
    }
  },
  {
    path: '/adi200210/index',
    name: 'adi200210',
    component: () => import('@/act2020/adi200210/index'),
    meta: {
      title: '用于视频、转换器通信的千兆位数字隔离器' // mps线下会议PPT下载-SCRM
    }
  },
  {
    path: '/infineon200218/index',
    name: 'infineon200218',
    component: resolve => require(['@/act2020/infineon200218/index'], resolve),
    meta: {
      title: '英飞凌' // scrm
    }
  },
  {
    path: '/keysight20200219/index',
    name: 'keysight200219',
    component: resolve => require(['@/act2020/keysight200219/index'], resolve),
    meta: {
      title: '从超低微功率电源效率分析着手来优化物联网终端功耗' // scrm
    }
  },
  {
    path: '/itech20200219/index',
    name: 'itech20200219',
    component: resolve => require(['@/act2020/itech200219/index'], resolve),
    meta: {
      title: '战“疫”我们能做什么？—ITECH医疗电子领域测试解决方案' // scrm
    }
  },
  {
    path: '/infineon200220/index',
    name: 'infineon200220',
    component: resolve => require(['@/act2020/infineon200220/index'], resolve),
    meta: {
      title: '英飞凌高效低频开关CoolMOS™S7系列' // scrm
    }
  },
  {
    path: '/meixin200226/index',
    name: 'meixin200226',
    component: resolve => require(['@/act2020/meixin200226/index'], resolve),
    meta: {
      title: '美信深入浅出低功耗MCU' // scrm
    }
  },
  {
    path: '/infineon200227/index',
    name: 'infineon200227',
    component: resolve => require(['@/act2020/infineon200227/index'], resolve),
    meta: {
      title: '英飞凌的直观传感解决方案——玻璃破碎报警系统 ' // scrm
    }
  },
  {
    path: '/novosense200320/index',
    name: 'novosense200320',
    component: resolve => require(['@/act2020/novosense200320/index'], resolve),
    meta: {
      title: '利用新一代隔离电压反馈技术解决线性光耦在电源应用中的痛点 ' // scrm
    }
  },
  {
    path: '/mps200320/index',
    name: 'mps200320200320',
    component: resolve => require(['@/act2020/mps200320/index'], resolve),
    meta: {
      title: '带NVDC路径管理的开关充电IC的工作机制' // scrm
    }
  },
  {
    path: '/mps200321/index',
    name: 'mps200321',
    component: resolve => require(['@/act2020/mps200321/index'], resolve),
    meta: {
      title: '应用于电表的ACDC设计' // scrm
    }
  },
  {
    path: '/mps200319/index',
    name: 'mps200319',
    component: resolve => require(['@/act2020/mps200319/index'], resolve),
    meta: {
      title: 'MPS电源模块在PCIe加速卡电源解决方案中的应用' // mps4.30直播 scrm
    }
  },
  {
    path: '/mps200318/index',
    name: 'mps200318',
    component: resolve => require(['@/act2020/mps200318/index'], resolve),
    meta: {
      title: '带NVDC路径管理的开关充电IC的工作机制' // mps5.8直播 scrm
    }
  },
  {
    path: '/mps200317/index',
    name: 'mps200317',
    component: resolve => require(['@/act2020/mps200317/index'], resolve),
    meta: {
      title: '应用于电表的ACDC技术' // mps5.15直播 scrm
    }
  },
  {
    path: '/keysight200330/index',
    name: 'keysight200330',
    component: resolve => require(['@/act2020/keysight200330/index'], resolve),
    meta: {
      title: '利用多路同步数采提升您产品的可靠性' // keysight 4.25直播只提问 scrm
    }
  },
  {
    path: '/keysight200331/index',
    name: 'keysight200331',
    component: resolve => require(['@/act2020/keysight200331/index'], resolve),
    meta: {
      title: '利用多路同步数采提升您产品的可靠性' // keysight 4.25直播提问+调查问卷 scrm
    }
  },
  {
    path: '/infineon200409/index',
    name: 'infineon200409',
    component: resolve => require(['@/act2020/infineon200409/index'], resolve),
    meta: {
      title: '英飞凌碳化硅MOSFET特性及驱动设计实验室直播' // infineon 5.26直播 只有提问 scrm
    }
  },
  {
    path: '/mouser200421/index',
    name: 'mouser200421',
    component: resolve => require(['@/act2020/mouser200421/index.vue'], resolve),
    meta: {
      title: '超级电容备份应用的Maxim解决方案' // 贸泽+美信5.29直播预报名
    }
  },
  {
    path: '/mouser200525/index',
    name: 'mouser200525',
    component: resolve => require(['@/act2020/mouser200525/index.vue'], resolve),
    meta: {
      title: '面向AI应用的高功率电源解决方案' // 贸泽+美信0525直播预报名
    }
  },
  {
    path: '/tek200422/index',
    name: 'tek200422',
    component: resolve => require(['@/act2020/tek200422/index'], resolve),
    meta: {
      title: '电源设计工厂-Tektronix' // 泰克活动 每次上滑滑动一屏
    }
  },
  {
    path: '/live200507/index',
    name: 'live200507Index',
    component: resolve => require(['@/act2020/live200507/index'], resolve),
    meta: {
      title: '逆变器训练营-从0到1做逆变' // 直播聚合页活动 集五张卡 --主页
    }
  },
  {
    path: '/live200507/card',
    name: 'live200507Card',
    component: resolve => require(['@/act2020/live200507/card'], resolve),
    meta: {
      title: '逆变器训练营-从0到1做逆变' // 直播聚合页活动 集五张卡 --集卡页
    }
  },
  {
    path: '/live200507/external',
    name: 'live200507External',
    component: resolve => require(['@/act2020/live200507/external'], resolve),
    meta: {
      title: '逆变器训练营-从0到1做逆变' // 直播聚合页活动 集五张卡 --套件介绍页
    }
  },
  {
    path: '/live200507/login',
    name: 'live200507Login',
    component: resolve => require(['@/act2020/live200507/login'], resolve),
    meta: {
      title: '逆变器训练营-从0到1做逆变' // 直播聚合页活动 集五张卡 --会员登录页
    }
  },
  {
    path: '/livegroup200512/index',
    name: 'livegroup200512Index',
    component: resolve => require(['@/act2020/livegroup200512/index'], resolve),
    meta: {
      title: '东儿500W-LLC直播群' // 东儿500W-LLC直播群
    }
  },
  {
    path: '/live/([a-z]?)108',
    name: 'infineon200521index',
    component: resolve => require(['@/act2020/infineon200521/index'], resolve),
    meta: {
      title: '英飞凌安全大师走进“云”校园' // 英飞凌上海交通大学合作直播-主页
    }
  },
  {
    path: '/infineon200521/form',
    name: 'infineon200521form',
    component: resolve => require(['@/act2020/infineon200521/form'], resolve),
    meta: {
      title: '英飞凌安全大师走进“云”校园' // 英飞凌上海交通大学合作直播-填写表单页
    }
  },
  {
    path: '/infineon200521/success',
    name: 'infineon200521success',
    component: resolve => require(['@/act2020/infineon200521/success'], resolve),
    meta: {
      title: '英飞凌安全大师走进“云”校园' // 英飞凌上海交通大学合作直播-提交成功页
    }
  },
  {
    path: '/livegroup200527/index',
    name: 'livegroup200527Index',
    component: resolve => require(['@/act2020/livegroup200527/index'], resolve),
    meta: {
      title: '逆变器实训营直播群' // 逆变器实训营直播群
    }
  },
  {
    path: '/keysight200530/index',
    name: 'keygisght200530',
    component: resolve => require(['@/act2020/keysight200530/index'], resolve),
    meta: {
      title: '和绘制波特图说再见' // 是德科技
    }
  },
  {
    path: '/page/([a-z]?)46',
    name: 'page54',
    component: resolve => require(['@/act2020/wbg200617/index'], resolve),
    meta: {
      title: '国际宽禁带直播节-2020电源网国际电力电子直播节'
    }
  },
  {
    path: '/emc200702/index([\/]?[a-z]?)',
    name: 'emc200702',
    component: resolve => require(['@/act2020/emc200702/index'], resolve),
    meta: {
      title: '电磁兼容直播节-2020电源网国际电力电子直播节'
    }
  },
  {
    path: '/emc200702/qrcode',
    name: 'emc200702Qrcode',
    component: resolve => require(['@/act2020/emc200702/groupQrCode.vue'], resolve),
    meta: {
      title: '电磁兼容直播节-2020电源网国际电力电子直播节'
    }
  },
  {
    path: '/emc0706/list([\/]?[a-z]?)',
    name: 'emc200706',
    component: resolve => require(['@/act2020/emc200706/index'], resolve),
    meta: {
      title: '通往EMC大师之路的六堂必修课'
    }
  },
  {
    path: '/emc200706/index([\/]?[a-z]?)',
    name: 'ecm200706LiveIntroduce',
    component: resolve => require(['@/act2020/emc200706/liveIntroduce.vue'], resolve),
    meta: {
      title: '通往EMC大师之路的六堂必修课'
    }
  },
  {
    path: '/yfl2008/index/([a-z]?)',
    name: 'infineon202008',
    component: resolve => require(['@/act2020/infineon2008/index.vue'], resolve),
    meta: {
      title: '2020年度英飞凌学者交流会'
    }
  },
  {
    path: '/yfl2008/pre',
    name: 'infineon2008_preform',
    component: resolve => require(['@/act2020/infineon2008/preform.vue'], resolve),
    meta: {
      title: '2020年度英飞凌学者交流会'
    }
  },
  {
    path: '/yfl2008/live',
    name: 'infineon2008_liveform',
    component: resolve => require(['@/act2020/infineon2008/liveform.vue'], resolve),
    meta: {
      title: '2020年度英飞凌学者交流会'
    }
  },
  {
    path: '/yfl2008/login',
    name: 'infineon2008_login',
    component: resolve => require(['@/act2020/infineon2008/login.vue'], resolve),
    meta: {
      title: '2020年度英飞凌学者交流会'
    }
  },
  {
    path: '/yfl2008/prev',
    name: 'infineon2008_prev',
    component: resolve => require(['@/act2020/infineon2008/livebefore.vue'], resolve),
    meta: {
      title: '2020年度英飞凌学者交流会'
    }
  },
  {
    path: '/yfl2008/liveIntroduce',
    name: 'infineon2008LiveIntroduce',
    component: resolve => require(['@/act2020/infineon2008/liveIntroduce.vue'], resolve),
    meta: {
      title: '2020年度英飞凌学者交流会'
    }
  },
  {
    path: '/acnet200715/index',
    name: 'acnet200715',
    component: resolve => require(['@/act2020/avnet200715/index.vue'], resolve),
    meta: {
      title: '安森美半导体汽车主驱逆变器解决方案'
    }
  },
  {
    path: '/infineon200716/index',
    name: 'infineon200716',
    component: resolve => require(['@/act2020/infineon200716/index.vue'], resolve),
    meta: {
      title: '英飞凌ToF-观看大咖讲座，Get“芯”灵感'
    }
  },
  {
    path: '/heilind200720/index',
    name: 'heilind200720',
    component: resolve => require(['@/act2020/heilind200720/index.vue'], resolve),
    meta: {
      title: '设计一个充满可能的世界'
    }
  },
  {
    path: '/keysight200724/index',
    name: 'keysight200724',
    component: resolve => require(['@/act2020/keysight200724/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight200724/download',
    name: 'keysight200724Download',
    component: resolve => require(['@/act2020/keysight200724/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/live200810/index', // 老寿直播逆变器学习套件优惠券活动
    name: 'live200810Index',
    component: resolve => require(['@/act2020/live200810/index'], resolve),
    meta: {
      title: '寿老师倾情打造逆变器实训营-学习套件新一批现货已就位'
    }
  },
  {
    path: '/live200810/parameter',
    name: 'live200810Parameter',
    component: resolve => require(['@/act2020/live200810/parameter'], resolve),
    meta: {
      title: ''
    }
  },
  {
    path: '/live200810',
    name: 'live200810Card',
    component: resolve => require(['@/act2020/live200810/card'], resolve),
    meta: {
      title: ''
    }
  },
  {
    path: '/eestar200817/index',
    name: 'eestar200817Index',
    component: resolve => require(['@/act2020/eestar200817/index'], resolve),
    meta: {
      title: '星球频道新上线,干货文章尽在掌中'
    }
  },
  {
    path: '/keysight200826/index',
    name: 'keysight200826',
    component: resolve => require(['@/act2020/keysight200826/index'], resolve),
    meta: {
      title: '先进电源系统（APS）挑战上电难题系列2'
    }
  },
  {
    path: '/recruit20200905/index',
    name: 'recruit20200905Index',
    component: resolve => require(['@/act2020/recruit20200905/index'], resolve),
    meta: {
      title: '星球招募计划' // 东儿500W-LLC直播群
    }
  },
  {
    path: '/keysight200917/index',
    name: 'keysight200917',
    component: resolve => require(['@/act2020/keysight200917/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight200917/download',
    name: 'keysight200917Download',
    component: resolve => require(['@/act2020/keysight200917/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
	    path: '/meeting201114/index',
	    name: 'meeting201114',
	    component: resolve => require(['@/act2020/meeting201114/index'], resolve),
	    meta: {
	        title: '会议签到'
	    }
  },
  {
    path: '/meeting201112/index',
    name: 'meeting201112index',
    component: resolve => require(['@/act2020/meeting201112/index'], resolve),
    meta: {
      title: '电源网(亚洲)工程师技术高峰论坛'
    }
  },
  {
    path: '/meeting201112/detail/:id',
    name: 'meeting201112detail',
    component: resolve => require(['@/act2020/meeting201112/detail'], resolve),
    meta: {
      title: '电源网(亚洲)工程师技术高峰论坛'
    }
  },
  {
    path: '/meeting201114/improve',
    name: 'improve',
    component: resolve => require(['@/act2020/meeting201114/improve'], resolve),
    meta: {
      title: '完善信息'
    }
  },
  {
	    path: '/meeting201114/success',
	    name: 'success',
	    component: resolve => require(['@/act2020/meeting201114/success'], resolve),
	    meta: {
	        title: '签到成功'
	    }
  },
  {
    path: '/meeting201114/authenticate',
    name: 'authenticate',
    component: resolve => require(['@/act2020/meeting201114/authenticate'], resolve),
    meta: {
      title: '资格认证'
    }
  },
  {
    path: '/meeting201114/identification',
    name: 'identification',
    component: resolve => require(['@/act2020/meeting201114/identification'], resolve),
    meta: {
      title: '资格认证'
    }
  },
  {
    path: '/keysight201013/index',
    name: 'keysight201013',
    component: resolve => require(['@/act2020/keysight201013/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight201013/download',
    name: 'keysight201013Download',
    component: resolve => require(['@/act2020/keysight201013/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/single201019/singleOne',
    name: 'singleOne',
    component: resolve => require(['@/act2020/single201019/single_one'], resolve),
    meta: {
      title: 'ARR9019纯正弦波逆变器后级专用芯片'
    }
  },
  {
    path: '/single201019/singleTwo',
    name: 'singleTwo',
    component: resolve => require(['@/act2020/single201019/single_two'], resolve),
    meta: {
      title: '电源网独家逆变器实训营从0到1做逆变'
    }
  },
  {
    path: '/live201114/index',
    name: 'liveExtend',
    component: resolve => require(['@/act2020/live201114/index'], resolve),
    meta: {
      title: '电源网直播班车'
    }
  },
  {
    path: '/single201019/singleThree',
    name: 'singleThree',
    component: resolve => require(['@/act2020/single201019/single_three'], resolve),
    meta: {
      title: '是德双十一行动-电源网'
    }
  },
  {
    path: '/getMaterial201118/index',
    name: 'getMaterial',
    component: resolve => require(['@/act2020/getMaterial201118/index'], resolve),
    meta: {
      title: '第五十六届电源网（亚洲）工程师技术高峰论坛'
    }
  },
  {
    path: '/getMaterial201118/download',
    name: 'getMaterial201118Download',
    component: resolve => require(['@/act2020/getMaterial201118/download'], resolve),
    meta: {
      title: '第五十六届电源网（亚洲）工程师技术高峰论坛全部演讲ppt'
    }
  },
  {
    path: '/single201201/index',
    name: 'single201201',
    component: resolve => require(['@/act2020/single201201/index'], resolve),
    meta: {
      title: '报名成功'
    }
  },
  {
    path: '/infineon201201/index',
    name: 'infineon201201',
    component: resolve => require(['@/act2020/infineon201201/index'], resolve),
    meta: {
      title: '英飞凌雷达解决方案，助力智能场景落地'
    }
  },
  {
    path: '/live201229/index',
    name: 'live201229',
    component: resolve => require(['@/act2020/live201229/index'], resolve),
    meta: {
      title: '天津会议-电源网直播班车'
    }
  },
  {
    path: '/live210112/index',
    name: 'live210112',
    component: resolve => require(['@/act2020/live210112/index'], resolve),
    meta: {
      title: '2021电源高新技术大会暨天津电子产业大会全部演讲PPT'
    }
  },
  {
    path: '/live210112/download',
    name: 'live210112Download',
    component: resolve => require(['@/act2020/live210112/download'], resolve),
    meta: {
      title: '2021电源高新技术大会暨天津电子产业大会全部演讲PPT'
    }
  }
]

export default Act2020
